module.exports = __webpack_public_path__ + "img/esultanza_1.28739633.jpg";